import * as React from "react";
import { Link } from "react-router-dom";
import C from "classnames";
export const CardLink = (props) => {
    return props.to ? (React.createElement(Link, { className: C("card-link", props.className), to: props.to, "data-testid": props.testId }, props.children)) : (React.createElement("a", { className: C("card-link", props.className), href: props.href, "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=CardLink.js.map